import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import  ProcessMasterService  from "../services/ProcessMaster";

export const createProcessMaster = createAsyncThunk("process-master/add",async (formData, { rejectWithValue })=>{
  try{
    const data =  await ProcessMasterService.addProcessDetails(formData);
    return data;
  }catch(err){
    if (!err.response) {
      throw err
    }
    return rejectWithValue(err.response.data)
  }
})
export const loadProcess = createAsyncThunk("process-master/list", async (data,thunkAPI)=>{
  try{
    const response = await ProcessMasterService.list(data);
    return response;
  }catch(err){
    console.log(err)
    if (!err.response) {
      throw err
    }
    return thunkAPI.rejectWithValue(err?.response?.data)
  }  
})

export const getProcessById = createAsyncThunk("process-master/byId", async (id,thunkAPI)=>{
  try{
    const response = await ProcessMasterService.getById(id);
    return response;
  }catch(err){
    console.log(err)
    if (!err.response) {
      throw err
    }
    return thunkAPI.rejectWithValue(err?.response?.data)
  }  
})

const initialState = {
  list:[],
  errors:false,
  success:false,
  loading:false,
  message:"",
  processMasterData:{}
    
}

const ProcessMasterSlice = createSlice({
  name : "processMaster",
  initialState,
  reducers:{
    reset:() => initialState,
    checkBom: ()=>{
      console.log("Bom Check")
    } 
  },
  extraReducers: {
    [createProcessMaster.pending] : (state) => {
      state.loading = true
      state.errors = false
      state.success = false
    },
    [createProcessMaster.fulfilled] : (state, action) => {
      state.loading = false;
      console.log(action.payload)
      if(!action.payload.success){
        state.errors = action.payload.error;    
      }else{
        state.success = action.payload.message; 
      }
            
    },
    [createProcessMaster.rejected] : (state, action) => {
      state.loading = false;
      if(!action.payload.success){
        state.errors = action.payload.error;
      }
    },

    [loadProcess.rejected] : (state, action) => {
      state.loading = false;
      console.log(action)
      if(!action?.payload?.success){
        state.errors = action?.payload?.error;
      }
    },
    [loadProcess.pending] : (state) => {
      state.loading = true
      state.error = false;
    },
    [loadProcess.fulfilled] : (state, action) => {
      state.loading = false
      state.success = action.payload.success
      if(action.payload.success){
        state.list = action.payload.data
      }else{
        state.message = action.payload.message
      }
            
    },

    [getProcessById.rejected] : (state, action) => {
      state.loading = false;
      if(!action?.payload?.success){
        state.errors = action?.payload?.error;
      }
    },
    [getProcessById.pending] : (state) => {
      state.loading = true
      state.error = false;
    },
    [getProcessById.fulfilled] : (state, action) => {
      state.loading = false
      state.success = action.payload.success
      if(action.payload.success){
        state.processMasterData = action.payload.data
      }else{
        state.message = action.payload.message
      }
            
    }
  }
})

export const {reset} = ProcessMasterSlice.actions
export default ProcessMasterSlice.reducer